import styled from 'styled-components';
import type { WithSX } from '@elfsight/lib-utils';
import { applySX } from '@elfsight/lib-utils';
import { getLineHeight } from '@elfsight/widget-utils';
import { usePost } from '../../post';
import { usePostSettings } from '../../post/utils';

interface TitleProps {
  centered?: boolean;
}

export function Title({ centered }: TitleProps) {
  const {
    textColor,
    textStyle: { fontSize: textSize }
  } = usePostSettings();
  const { title } = usePost();

  if (!title) {
    return null;
  }

  return (
    <StyledTitle
      dangerouslySetInnerHTML={{ __html: title }}
      $sx={{
        color: textColor,
        fontSize: textSize,
        textAlign: centered ? 'center' : 'left',
        lineHeight: `${getLineHeight({ fontSize: textSize })}px`
      }}
    />
  );
}

const StyledTitle = styled.div<WithSX>`
  ${applySX};
  width: 100%;
  display: inline-block;
  font-weight: bold;
  margin-bottom: 10px;
`;
